import { useEffect } from "react";
import { ensurePushSubscription } from "./push-client";
import { isPushReconciled, markPushReconciled } from "./push-sync-state";

/**
 * Keeps the server's idea of «this browser» true in the customer the person is working in.
 *
 * WHY IT HAS TO BE IN THE SHELL and not on the settings screen. The browser's push subscription is
 * one thing; a `push_subscriptions` row is a (customer, person) thing. Somebody who switched the
 * switch on in customer A and then moved to customer B was subscribed in the browser, told «Bu
 * cihazda açık» on screen, and had no row in B — so the worker found no device for them there and
 * they got nothing, with nothing on screen suggesting a second tap would help (review, finding 6).
 * A reconcile that only ran on the notification settings screen would fix the sentence for people
 * who happen to visit it; this fixes the delivery for everyone.
 *
 * WHAT IT COSTS SOMEBODY WHO NEVER TURNED IT ON: nothing. Two synchronous checks (`Notification`
 * exists, permission is `granted`) end it before any request — and it NEVER asks for permission,
 * which stays where K6 put it: inside the click on the switch, and nowhere else.
 *
 * Once per customer per page load: the PUT is idempotent, but a repeat on every remount would be a
 * write nobody asked for. A failure is not remembered, so the next mount tries again.
 */

export function PushSubscriptionSync({ tenantId }: { tenantId: string | null }) {
  useEffect(() => {
    if (!tenantId || isPushReconciled(tenantId)) return;
    void ensurePushSubscription().then((state) => {
      if (state.status === "on") markPushReconciled(tenantId);
    });
  }, [tenantId]);

  return null;
}
